// Loads editable content (DEF dictionary and DISCLAIMER_TEXT) from
// window.__APP_DEFINITIONS (declared in /public/definitions.js, loaded
// via a <script> tag in index.html) and merges the values into the
// objects exported by constants.js (in place, preserving the original
// references so that every import site keeps working).
//
// Using a <script> tag (instead of fetching JSON) makes the file editable
// in place after build and works even when index.html is opened directly
// from the local filesystem via file://.
//
// Defaults stay in constants.js and are used when the global is missing
// or malformed.
import { DEF, DISCLAIMER_TEXT } from './constants';

const TARGETS = {
    DEF,
    DISCLAIMER_TEXT,
};

/**
 * Replace the contents of `target` with the contents of `source` while
 * preserving the original reference. Handles both plain objects and arrays.
 */
const mergeInPlace = (target, source) => {
    if (Array.isArray(target) && Array.isArray(source)) {
        target.length = 0;
        target.push(...source);
        return;
    }
    if (target && typeof target === 'object' && source && typeof source === 'object') {
        for (const key of Object.keys(target)) {
            delete target[key];
        }
        Object.assign(target, source);
    }
};

/**
 * Read window.__APP_DEFINITIONS and overlay its contents onto the shared
 * constants. Returns a Promise for API consistency; resolves synchronously.
 */
export const loadDefinitions = async () => {
    try {
        const data = typeof window !== 'undefined' ? window.__APP_DEFINITIONS : null;
        if (!data || typeof data !== 'object') {
            console.warn('definitions - window.__APP_DEFINITIONS is not set, using defaults');
            return;
        }
        for (const [key, value] of Object.entries(data)) {
            if (TARGETS[key] !== undefined) {
                mergeInPlace(TARGETS[key], value);
            }
        }
    } catch (err) {
        console.error('definitions - failed to read window.__APP_DEFINITIONS, using defaults:', err);
    }
};
